import { render, staticRenderFns } from "./match-layout.vue?vue&type=template&id=739991de&scoped=true"
import script from "./match-layout.vue?vue&type=script&lang=js"
export * from "./match-layout.vue?vue&type=script&lang=js"
import style0 from "./match-layout.vue?vue&type=style&index=0&id=739991de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739991de",
  null
  
)

export default component.exports